import classNames from "classnames";

type Props = { extraClasses?: string };

export const SettingsCard: React.FC<Props> = ({ children, extraClasses }) => {
  return (
    <div
      className={classNames(
        "rounded-xl border border-[#E4E9F2] bg-white",
        extraClasses,
      )}>
      {children}
    </div>
  );
};
